import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'
import type OverlapPeriod from 'modules/work_schedules/store/models/OverlapPeriod'

export interface ISchedule {
  id: string
  name: string
  company_id: string
  archived_at: string | null
  created_at: string
  updated_at: string
  periods: OverlapPeriod[]
  employees: string[]
}

class Schedule extends Model<ISchedule> {
  constructor(attr: ISchedule) {
    super(attr)
    makeObservable(this, {
      employeeIds: computed,
      archived: computed,
    })
  }

  static urlRoot() {
    return '/work_schedule/schedules'
  }

  get employeeIds(): string[] {
    return this.attributes.employees
  }

  get archived(): boolean {
    return this.attributes.archived_at !== null
  }

  async archive(): Promise<void> {
    await this.rpc('toggle_archive')
    await this.fetch()
  }
}

export default Schedule
